import { toast } from "react-toastify";

/**
 * Envía mensaje al usuario de que todo ha funcionado correctamente
 * @param {String} mensaje 
 */
export const mensajeExitoso = (mensaje, tiempo = 1500) => {
    toast.success(mensaje, {
        position: "top-right",
        autoClose: tiempo,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
}